import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import StrapiService from '../../../services/strapi.service';
import { IStrapiDocuments } from '../../../interfaces/strapi';
import {
  IMaintenanceObject,
  MaintenanceData,
  MaintenanceService,
} from '../../../services/maintenance.service';

@Component({
    selector: 'app-maintenence-page',
    templateUrl: './maintenence-page.component.html',
    styleUrls: ['./maintenence-page.component.scss'],
    imports: [NgIf],
})
export class MaintenencePageComponent implements OnInit {
  public document: any = null;

  constructor(
    public readonly strapi: StrapiService,
    private readonly maintenanceService: MaintenanceService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    //   redirect from maintenance page if it is not enabled
    this.maintenanceService.getMaintenanceStatus().subscribe({
      next: ({ data }: { data: MaintenanceData }) => {
        if (data?.enable_web) {
          this.router.navigate(['/app']).finally(() => false);
        }
      },
      error: (_error: HttpErrorResponse) => {
        //   if there is an error stay on this page
      },
    });

    this.strapi
      .getDocumentByUID('maintenance-pages', 'web', {
        populate: {
          logo: { populate: '*' }
        },
      })
      .subscribe({
        next: (data: IStrapiDocuments<IMaintenanceObject>) => {
          this.document = data.data[0].attributes;
        },
      });
  }
}
